import type { ActivityStaticData } from '../../activityDetails';
import type { Distance } from '../models';

export function getDistances(
  activityDetails: ActivityStaticData | undefined
): Distance[] | undefined {
  if (!activityDetails) {
    return;
  }
  const distanceValues = Object.values(
    activityDetails.staticInfo.distances ?? {}
  );

  if (distanceValues.length === 0) {
    return;
  }

  return distanceValues
    .map((value) => ({
      description: value.description,
      distanceMeters: value.value,
    }))
    .sort((a, b) => a.distanceMeters - b.distanceMeters);
}
